import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import axiosInstance from "../api/axiosInstance";

interface SmtpGateways {
    id?: number;
    gateway_name?: string;
    name?: string;
    host?: string;
    port?: number;
    user?: string;
    password?: string;
    from_email?: string;
    createdAt?: string;
    updatedAt?: string;
}

interface SmtpGatewaysState {
    smtpgatewaysviewdata: SmtpGateways[];
    info: { count: number; current_page: number; limit: number; total_page: number } | null;
    error: string | null;
    loading: boolean;
}

// ==================view-Smtpgatewaylist-api-start=============
export const GetSmtpGatewayView = createAsyncThunk<
    SmtpGateways,
    number,
    { rejectValue: string }
>(
    'smtpgatewaysviewdata/GetSmtpGatewayView',
    async (id, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(`/api/admin/smtp-gateways/${id}`);
            return response.data.SMTPGateway;

        } catch (error: any) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue(error.message);
        }
    }
);
// ==================view-Smtpgatewaylist-api-end=============

const initialState: SmtpGatewaysState = {
    smtpgatewaysviewdata: [],
    info: null,
    error: null,
    loading: false,
};

const smtpgatewaysviewSlice = createSlice({
    name: 'Smtpgateways',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(GetSmtpGatewayView.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(GetSmtpGatewayView.fulfilled, (state, action: PayloadAction<SmtpGateways>) => {
                state.loading = false;
                state.error = null;
                state.smtpgatewaysviewdata = [action.payload];
            })
            .addCase(GetSmtpGatewayView.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            });
    },
});


export default smtpgatewaysviewSlice.reducer;
